/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spellcheck_Ok_ButtonInputs */

const en_spellcheck_ok_button = /** @type {(inputs: Spellcheck_Ok_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ok`)
};

const fr_spellcheck_ok_button = /** @type {(inputs: Spellcheck_Ok_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

const de_spellcheck_ok_button = /** @type {(inputs: Spellcheck_Ok_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

const it_spellcheck_ok_button = /** @type {(inputs: Spellcheck_Ok_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

const ru_spellcheck_ok_button = /** @type {(inputs: Spellcheck_Ok_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Хорошо`)
};

const es_spellcheck_ok_button = /** @type {(inputs: Spellcheck_Ok_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De acuerdo`)
};

const zh_cn2_spellcheck_ok_button = /** @type {(inputs: Spellcheck_Ok_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`好的`)
};

const ja_spellcheck_ok_button = /** @type {(inputs: Spellcheck_Ok_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`わかりました`)
};

const hi_spellcheck_ok_button = /** @type {(inputs: Spellcheck_Ok_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ठीक है`)
};

const pt_pt2_spellcheck_ok_button = /** @type {(inputs: Spellcheck_Ok_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

/**
* | output |
* | --- |
* | "Ok" |
*
* @param {Spellcheck_Ok_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spellcheck_ok_button = /** @type {((inputs?: Spellcheck_Ok_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spellcheck_Ok_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_spellcheck_ok_button(inputs)
	if (locale === "de") return de_spellcheck_ok_button(inputs)
	if (locale === "it") return it_spellcheck_ok_button(inputs)
	if (locale === "ru") return ru_spellcheck_ok_button(inputs)
	if (locale === "es") return es_spellcheck_ok_button(inputs)
	if (locale === "zh-CN") return zh_cn2_spellcheck_ok_button(inputs)
	if (locale === "ja") return ja_spellcheck_ok_button(inputs)
	if (locale === "hi") return hi_spellcheck_ok_button(inputs)
	if (locale === "pt-PT") return pt_pt2_spellcheck_ok_button(inputs)
	return en_spellcheck_ok_button(inputs)
});